import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Spinner } from "react-bootstrap";
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../../api-client/MyApiClient';
import { sports } from "../../../../components/Util/enum";
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";
import { dateTimeSort } from '../../../../components/Util/oders';

import { formattaPrezzo } from "../../../../components/Util/prezzi";
// Valori dei filtri a chip, come compaiono nella lista.
const STATO_OPTIONS = ['Pagato', 'Non pagato', 'Rimborsato', 'Annullato'];

export const UserCoursesTable = ({ course_id = null, cardTitle = '', headerButtons = null }) => {

    const navigate = useNavigate();


	const [data_json, setDataJson] = useState(null);
	const isFiltered = course_id !== null;
	const [sportFilter, setSportFilter] = useState('');
	// Chip a scelta multipla: all'inizio tutti accesi
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	// Gli sport (colonna visibile solo nella lista completa) sono quelli degli acquisti caricati.
	const sportOptions = useMemo(
		() => [...new Set((data_json || []).map((row) => row.sportType).filter(Boolean))].sort(),
		[data_json],
	);

	const filteredData = useMemo(
		() =>
			data_json &&
			data_json.filter(
				(row) =>
					(!sportFilter || row.sportType === sportFilter) &&
					filtroMultiplo(statoFilter, STATO_OPTIONS, row.status_label?.label),
			),
		[data_json, sportFilter, statoFilter],
	);

	const [loadingShowed, setLoadingShowed] = useState(false);

	const data_column = [
		{
			Header: 'Data',
			Footer: 'Data',
			accessor: 'createdAt',
			disableGlobalFilter: true,
			sortType: dateTimeSort,
			disableFilters: true
		},
		{
			Header: 'Nome e cognome',
			accessor: 'playerName',
			Cell: ({ row }) => {
				const isJunior = row.original.isJunior;
				return (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img
							src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_USER}
							alt={row.original.playerName}
							style={{
								width: '40px',
								height: '40px',
								borderRadius: '50%',
								marginRight: '10px'
							}}
						/>
						<div>
							{row.original.playerName}
							{isJunior && (
								<div>
									<span style={{fontSize: '12px', color: 'white', backgroundColor: 'red', marginLeft: '10px', padding: '2px 5px', borderRadius: '5px'}}>Junior</span>
								</div>
							)}
						</div>
					</div>
				)
			}
		},
		...(!isFiltered ? [{
			Header: 'Corso',
			Footer: 'Corso',
			accessor: 'course_name',
		},
		{
			Header: 'Sport',
			Footer: 'Sport',
			accessor: 'sportType',
			disableGlobalFilter: true,
		}] : [{
			Header: 'Squadra',
			Footer: 'Squadra',
			accessor: 'teamName',
		}]),
		{
			Header: 'Prezzo',
			Footer: 'Prezzo',
			accessor: 'price',
			disableGlobalFilter: true,
		},
		{
			Header: 'Stato pagamento',
			Footer: 'Stato pagamento',
			accessor: 'status_label',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (
					<div className="d-flex align-items-center">
						<i className={`fa fa-circle me-1 ${value?value.class:''}`}></i>
						{value?value.label:''}
					</div>
				)
			},
		},
	];

	function openDetail(row) {
		navigate('/struttura/booking/usercourses/'+row.id);
	}

	const fetchData = async () => {
		try {
			const tokenDetailsString = sessionStorage.getItem('userDetails');
			if (tokenDetailsString) {
				const tokenDetails = JSON.parse(tokenDetailsString);
				let token = tokenDetails.idToken;
				const apiClient = new MyApiClient();

				setLoadingShowed(true);
				const calls = [apiClient.getUserBookingCourses(token, course_id)];
				if (isFiltered) calls.push(apiClient.getBookingCourseTeams(token, course_id));
				const [bookingCourses, courseTeams] = await Promise.all(calls);

				let teamsByUserId = {};
				if (courseTeams && Array.isArray(courseTeams) && !courseTeams.error) {
					const memberFetches = courseTeams.map(t => apiClient.getBookingCourseTeamMembers(token, t.id).then(members => ({ team: t, members })));
					const results = await Promise.all(memberFetches);
					results.forEach(({ team, members }) => {
						if (Array.isArray(members)) {
							members.forEach(m => { if (m.userId) teamsByUserId[m.userId] = team.name; });
						}
					});
				}
				setLoadingShowed(false);

				if(bookingCourses) {
					let data = [];
					bookingCourses.forEach(element => {

						const options = { year: 'numeric', month: '2-digit', day: '2-digit' };

						const startDateEl = element.startDate;
						const startDate = startDateEl ? new Date(startDateEl) : null;
						const formattedStartDate = startDate ? startDate.toLocaleDateString('it-IT', options) : '-';

						const endDateEl = element.endDate;
						const endDate = endDateEl ? new Date(endDateEl) : null;
						const formattedEndDate = endDate ? endDate.toLocaleDateString('it-IT', options) : '-';

						const createdAt = element.createdAt;
						const dateCreated = new Date(createdAt);
						// Solo la data, senza orario
						const formattedDate = dateCreated.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' });

						let image = null;
                        if(element.juniorName) {
                            if(element.juniorPicture && element.juniorPicture.uri) {
								image = element.juniorPicture.uri;
							}
                        } else {
							if(element.playerPicture && element.playerPicture.uri) {
								image = element.playerPicture.uri;
							}
						}

						let status = null;
						if(element.status === 'PAID') {
							status = {
								"label": "Pagato",
								"class": "text-success"
							};
						} else if(element.status === 'UNPAID') {
							status = {
								"label": "Non pagato",
								"class": "text-primary"
							};
						} else if(element.status === 'REFUNDED') {
							status = {
								"label": "Rimborsato",
								"class": "text-warning"
							};
						} else if(element.status === 'CANCELLED') {
							status = {
								"label": "Annullato",
								"class": "text-error"
							};
						}

						let sportLabel = '';
						sports.forEach(element2 => {
							if(element2.value === element.sportType) {
								sportLabel = element2.label;
							}
						});

						const userId = element.juniorId || element.playerId;
						let row = {
							"id": element.id,
							"playerName": element.juniorName ? element.juniorName : element.playerName,
							"course_name": element.course_name,
							"sportType": sportLabel,
							"teamName": teamsByUserId[userId] || '-',
							"startDate": formattedStartDate,
							"endDate": formattedEndDate,
							"price": formattaPrezzo(element.price),
							"status": element.status,
							"status_label": status,
							"imageUrl": image,
							"isJunior": element.juniorName !== '',
							"createdAt": formattedDate
						};
						data.push(row);
						
					});
					setDataJson(data);
				}
			}
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<TabellaLista
				cardTitle={cardTitle.trim()}
				hasSearch={true}
				searchPlaceholder={isFiltered ? 'Cerca per nome o squadra' : 'Cerca per nome o corso'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						{!isFiltered && <ChipFilter label="Sport" options={sportOptions} value={sportFilter} onChange={setSportFilter} asDropdown />}
						<ChipFilter label="Stato pagamento" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
					</div>
				}
				data_column={data_column}
				data_json={filteredData}
				openColumn={'playerName'}
				openRow={(row) => openDetail(row)}
				hasAddMore={!isFiltered}
				linkAddMore={'/struttura/corsi/partecipanti/nuovo'}
				labelAddMore={'Nuova vendita corso'}
				headerButtons={headerButtons}
				modalCallBack={() => setModalCentered(true)}
				sort_by={'createdAt'}
                sort_type={'desc'}
			/>
		</>
	)
}
export default UserCoursesTable;